import { CashAssetMeta } from '/@/modules/asset/models/meta/CashAssetMeta';
import { RealEstateMeta } from '/@/modules/asset/models/meta/RealEstateMeta';
import { AssetType } from '/@/modules/asset/enums/AssetType';
import { VehicleAssetMeta } from '/@/modules/asset/models/meta/VehicleAssetMeta';
import { BelongingAssetMeta } from '/@/modules/asset/models/meta/BelongingAssetMeta';
import { ArtJewelryAssetMeta } from '/@/modules/asset/models/meta/ArtJewelryAssetMeta';
import { PrivateStockAssetMeta } from '/@/modules/asset/models/meta/PrivateStockAssetMeta';
import { PensionPlanAssetMeta } from '/@/modules/asset/models/meta/PensionPlanAssetMeta';
import { BankAccountAssetMeta } from '/@/modules/asset/models/meta/BankAccountAssetMeta';
import { LifeInsuranceAssetMeta } from '/@/modules/asset/models/meta/LifeInsuranceAssetMeta';
import { FirearmAssetMeta } from '/@/modules/asset/models/meta/FirearmAssetMeta';
import { CryptocurrencyAssetMeta } from '/@/modules/asset/models/meta/CryptocurrencyAssetMeta';
import { FuneralPreArrangementAssetMeta } from '/@/modules/asset/models/meta/FuneralPreArrangementAssetMeta';
import { IncomeAssetMeta } from '/@/modules/asset/models/meta/IncomeAssetMeta';
import { OtherAssetMeta } from '/@/modules/asset/models/meta/OtherAssetMeta';
import { LandAssetMeta } from '/@/modules/asset/models/meta/LandAssetMeta';

export class AssetMeta {
  static factory(type, meta = {}) {
    switch (type) {
      case AssetType.ART_JEWELRY.key:
        return new ArtJewelryAssetMeta(meta);
      case AssetType.BANK_ACCOUNT.key:
        return new BankAccountAssetMeta(meta);
      case AssetType.BELONGING.key:
        return new BelongingAssetMeta(meta);
      case AssetType.CASH.key:
        return new CashAssetMeta(meta);
      case AssetType.CRYPTOCURRENCY.key:
        return new CryptocurrencyAssetMeta(meta);
      case AssetType.FIREARM.key:
        return new FirearmAssetMeta(meta);
      case AssetType.INCOME.key:
        return new IncomeAssetMeta(meta);
      case AssetType.LIFE_INSURANCE.key:
        return new LifeInsuranceAssetMeta(meta);
      case AssetType.PENSION_PLAN.key:
        return new PensionPlanAssetMeta(meta);
      case AssetType.PRIVATE_STOCK.key:
        return new PrivateStockAssetMeta(meta);
      case AssetType.REAL_ESTATE.key:
        return new RealEstateMeta(meta);
      case AssetType.VEHICLE.key:
        return new VehicleAssetMeta(meta);
      case AssetType.FUNERAL_PRE_ARRANGEMENT.key:
        return new FuneralPreArrangementAssetMeta(meta);
      case AssetType.OTHER.key:
        return new OtherAssetMeta(meta);
      case AssetType.LAND.key:
        return new LandAssetMeta(meta);
      default:
        return null;
    }
  }
}
